import request from "@/utils/httpRequest";
export default {
  webList: function (params) {
    return request({
      url: "/cms/content/cmsContents/webList",
      params: params,
      method: 'get'
    });
  },
  webQueryById: function (id) {
    return request({
      url: "/cms/content/cmsContents/webQueryById",
      params: {
        id:id
      },
      method: 'get'
    });
	},
	headerTreeData: function (params) {
		return request({
			url: "/cms/column/cmsColumn/treeData",
			params: params,
			method: 'get'
		});
	},
}